import React, { FC } from 'react';

import { Table } from '@column/column-ui-kit';

import { useBankAccountOptions } from '~/components/fields/BankAccountDropdown';

interface BankAccountCellProps {
  isEditable?: boolean;
  value?: string;
  onChange?: ({ description, id }: { description: string; id: string }) => void;
}

export const BankAccountCell: FC<BankAccountCellProps> = ({ value, onChange: onChangeProp, isEditable }) => {
  const { options, hiddenOptions, search, bankAccounts } = useBankAccountOptions({ value });

  return (
    <Table.OptionCell
      value={value}
      options={options}
      hiddenOptions={hiddenOptions}
      fullWidth
      isEditable={isEditable}
      emptyMessage="No accounts found"
      search
      searchLabel="Search accounts"
      onSearchChange={(searchValue?: string) => search(searchValue)}
      onChange={(newValue: string) => {
        const ba = bankAccounts.find((a) => a.id === newValue);
        onChangeProp?.({
          description: ba?.description ?? '',
          id: newValue,
        });
      }}
    />
  );
};
